import React, { HTMLProps } from 'react';
import { fullClassName } from 'Utilities';

export const DropdownArrowIcon: React.FC<HTMLProps<HTMLSpanElement>> = ({
  className,
  ...otherProps
}) => {
  return <span className={fullClassName('k-icon k-i-arrow-s', className)} />;
};

export const DropdownArrowIconUp: React.FC<HTMLProps<HTMLSpanElement>> = ({
  className,
  ...otherProps
}) => {
  return (
    <span className={fullClassName('k-icon k-i-arrow-60-up', className)} />
  );
};

export const RightArrowIcon: React.FC<HTMLProps<HTMLSpanElement>> = ({
  className,
  ...otherProps
}) => {
  return <span className={fullClassName('k-icon k-i-arrow-e', className)} />;
};

export const PaginationFirstIcon: React.FC<HTMLProps<HTMLSpanElement>> = ({
  className,
  ...otherProps
}) => {
  return <span className={fullClassName('k-icon k-i-arrow-end-left', className)} {...otherProps} />;
};

export const PaginationPrevIcon: React.FC<HTMLProps<HTMLSpanElement>> = ({
  className,
  ...otherProps
}) => {
  return <span className={fullClassName('k-icon k-i-arrow-60-left', className)} {...otherProps} />;
};

export const PaginationNextIcon: React.FC<HTMLProps<HTMLSpanElement>> = ({
  className,
  ...otherProps
}) => {
  return <span className={fullClassName('k-icon k-i-arrow-60-right', className)} {...otherProps} />;
};

export const PaginationLastIcon: React.FC<HTMLProps<HTMLSpanElement>> = ({
  className,
  ...otherProps
}) => {
  return <span className={fullClassName('k-icon k-i-arrow-end-right', className)} {...otherProps} />;
};
